<template>
  <MasterDetail
    ref="masterDetail"
    :cols="cols"
    :confirmDeleteMessage="confirmDeleteMessage"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :resourceUrl="resourceUrl"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MasterDetail
  },
  data() {
    return {
      opts: {
        businessUnits: [],
        switchOpts: [
          {
            value: true,
            label: "Ativo"
          },
          {
            value: false,
            label: "Inativo"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      return [
        {
          key: "codigo",
          name: "Código",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        },
        {
          key: "nome",
          name: "Nome",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        },
        {
          key: "business_unit_id",
          name: "Business Unit",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "businessUnits", key: "id", name: "nome" },
          rules: [{ rule: "required" }]
        },
        {
          key: "ativo",
          name: "Status",
          type: this.$fieldTypes.SWITCH,
          defaultValue: true,
          rel: { to: "switchOpts", key: "value", name: "label" }
        }
      ];
    },
    resourceUrl() {
      return `/v1/ativacaoped/${this.clientId}/centros-de-custo`;
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    } else {
      this.getBusinessUnits();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
        return;
      }

      // `opts.businessUnits` é carregado no `created`: na troca de empresa
      // precisa ser recarregado para o cliente novo.
      this.getBusinessUnits();
    }
  },
  methods: {
    confirmDeleteMessage({ nome }) {
      return `Deseja excluir o centro de custo ${nome}?`;
    },
    async getBusinessUnits() {
      try {
        const resource = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/business-units/selecao`
        );
        const response = await resource.get();
        this.opts.businessUnits = response;
      } catch (error) {
        this.opts.businessUnits = [];

        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    goToHome() {
      this.notify({
        error:
          "Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada."
      });
      this.$router.push({ name: "homepage" });
    }
  }
};
</script>
